module.exports = "/365FarmNet/dist/crop.6392d12101c2a9c67277fa1b584cc33a.html";